// src/models/egresoFilesModel.js

import pb from '../lib/pocketbase.js';

// Obtener archivos de egreso paginados
export async function getEgresoFiles(egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoFiles').getList(page, perPage, {
      filter: `egresoCab = "${egresoCabId}"`,
      $autoCancel: false
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      page: response.currentPage,
    };
  } catch (error) {
    console.error("Error fetching egresoFiles:", error);
    throw new Error("Error al obtener los archivos de egreso");
  }
}

// Subir un nuevo archivo de egreso
export async function uploadEgresoFile(egresoFile) {
  try {
    const response = await pb.collection('egresoFiles').create(egresoFile);
    return response;
  } catch (error) {
    console.error("Error uploading egresoFile:", error);
    throw new Error("Error al subir el archivo de egreso");
  }
}

// Actualizar un archivo de egreso
export async function updateEgresoFile(id, egresoFile) {
  try {
    const response = await pb.collection('egresoFiles').update(id, egresoFile);
    return response;
  } catch (error) {
    console.error("Error updating egresoFile:", error);
    throw new Error("Error al actualizar el archivo de egreso");
  }
}

// Eliminar un archivo de egreso
export async function deleteEgresoFile(id) {
  try {
    await pb.collection('egresoFiles').delete(id);
  } catch (error) {
    console.error("Error deleting egresoFile:", error);
    throw new Error("Error al eliminar el archivo de egreso");
  }
}

// Buscar archivos de egreso por nombre con paginación
export async function searchEgresoFiles(query, egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoFiles').getList(page, perPage, {
      filter: `nombre ~ "${query}" && egresoCab = "${egresoCabId}"`,
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching egresoFiles:", error);
    throw new Error("Error al buscar los archivos de egreso");
  }
}